import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Select, StatusIndicator } from '@amzn/awsui-components-core';
import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import { ContentPriorityOptions } from '../utils/SelectableOptions';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import { contentPriorityDisplayNames } from '../utils/DisplayNames';
import { ContentQueryContext } from '../content/table/ContentQueryContext';

interface Props {
  workflow: ContentWorkflow;
}

const ContentPrioritySelect = ({ workflow }: Props) => {
  const { contentId, contentPriority } = workflow;
  const [loading, setIsLoading] = useState(false);
  const [allOptions, setAllOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const { queryState, dispatchQueryState } = useContext(ContentQueryContext);
  const mplServiceClient: IMplServiceClient = useMemo(() => MplServiceClientFactory.create(), []);
  const contentPriorityInitialValue = contentPriority
    ? { value: contentPriority, label: contentPriorityDisplayNames.get(contentPriority) }
    : null;

  useEffect(() => {
    const allContentPriorityOptions = [
      ...ContentPriorityOptions,
      { id: 0, label: '<Remove priority>', value: 0 },
    ];
    // @ts-expect-error TS2345 - strict migration
    setAllOptions(allContentPriorityOptions);
    // @ts-expect-error TS2345 - strict migration
    setSelectedOption(contentPriorityInitialValue);
  }, [contentId, contentPriority]); // eslint-disable-line react-hooks/exhaustive-deps

  const updatePriority = async (updatedOption: any) => {
    setIsLoading(true);
    try {
      if (updatedOption.value) {
        await mplServiceClient.updateContentPriority(contentId, updatedOption.value);
      } else {
        await mplServiceClient.deleteContentPriority(contentId);
      }
      setSelectedOption(updatedOption);
      // @ts-expect-error TS18048 - strict migration
      const tableItem = queryState.queryResult.find((wf) => wf.contentId === contentId);
      // @ts-expect-error TS18048 - strict migration
      tableItem.workflow.contentPriority = updatedOption.value;
      // @ts-expect-error TS2488 - strict migration
      const modifiedQueryResult = [...queryState.queryResult];
      dispatchQueryState({ queryResult: modifiedQueryResult });
    } catch (e) {
      // @ts-expect-error TS2345 - strict migration
      setSelectedOption(contentPriorityInitialValue);
    } finally {
      setIsLoading(false);
    }
  };

  if (loading) {
    return <StatusIndicator type="loading">Updating priority...</StatusIndicator>;
  } else {
    return (
      <Select
        selectedOption={selectedOption}
        onChange={({ detail }) => updatePriority(detail.selectedOption)}
        options={allOptions}
        selectedAriaLabel="Select"
        expandToViewport
        ariaRequired
      />
    );
  }
};

export default ContentPrioritySelect;
